import { SCORM } from 'pipwerks-scorm-api-wrapper';
import API from 'services/scorm/API';

let interactionsLockedData = {};
let suspend_data: any = undefined;

const getSuspendData = (): string | undefined => {
  let version = SCORM.version
  return version ? SCORM.get(API[version].suspend_data) : undefined;
}

const getInteractionsLockedData = (id: string | null = null) => {
  return id ? interactionsLockedData[id] : interactionsLockedData;
};

const setInteractionsLockedData = id => {
  interactionsLockedData[id] = 0;
};

const getMultichoiceData = () => {
  let local_suspend_data;

  if (suspend_data) {
    local_suspend_data = suspend_data
  } else {
    local_suspend_data = getSuspendData();
    local_suspend_data = local_suspend_data
      ? JSON.parse(local_suspend_data)
      : {};

    suspend_data = local_suspend_data
  }

  return local_suspend_data?.multichoiceData || {}
};

export {
  getInteractionsLockedData,
  setInteractionsLockedData,
  getMultichoiceData,
};
